import { PopoverHandlerService } from 'src/app/services/popover-handler.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiSdkService } from './services/api-sdk.service';
import { UserI } from './interfaces/user.interface';
import { MixpanelService } from './services/mixpanel/mixpanel.service';
import { TranslateService } from '@ngx-translate/core';
import { LegacyHintService } from './services/legacy-hint.service';
import { environment } from '../environments/environment';

/**
 * A legacy account moved to the new platform (`platformAccount: true`, linked by hand) is sent there: this panel
 * signs in no platform account, so only an older session reaches this. The CEO pages are left alone.
 */
export function movedToPlatform(user: { platformAccount?: boolean } | null | undefined, path: string): boolean {
  return user?.platformAccount === true && !path.startsWith('/ceo');
}

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  userData: UserI = null as any;
  smallScreen: boolean = false;
  currentLang: string = 'en';
  showHeader: boolean = false;
  constructor(
    private router: Router,
    private apiSdkService: ApiSdkService,
    private popoverHandlerService: PopoverHandlerService,
    private mixpanelService: MixpanelService,
    private translate: TranslateService,
    private legacyHint: LegacyHintService,
  ) {}

  async ngOnInit() {
    try {
      const browserLang = this.translate.getBrowserLang();
      console.log('Browser language:', browserLang);
      const selectedLang = localStorage.getItem('selectedLang') as string;

      this.currentLang = selectedLang || (browserLang?.match(/en|es/) ? browserLang : 'en');


      console.log('Selected language:', this.currentLang);
      this.translate.use(this.currentLang);
    } catch (error) {
      console.error('Error initializing translation:', error);
    }

    this.mixpanelService.init("65369ba08ffd157ee0b6d0119af92cfc");

    this.detectSmallScreen();
    await this.getUserData();

    // Subscribe to router events to update header visibility on navigation
    this.router.events.subscribe(() => {
      this.updateHeaderVisibility();
    });
  }

  async getUserData() {
    const result = await this.apiSdkService.getFullUserData(true);
    this.userData = result?.success?.data;

    if (movedToPlatform(this.userData as any, window.location.pathname)) {
      // the same order as the sign-out: `tot_legacy=0` first, so the platform does not hand them back here
      localStorage.removeItem('token');
      this.legacyHint.markSignedOut();
      window.location.href = `${environment.platformUrl}/login`;
      return;
    }

    // Update language if user doesn't have one set
    if (this.userData && !this.userData.language) {
      try {
        await this.apiSdkService.updateLanguage(this.currentLang);
        console.log('Language set to:', this.currentLang);
      } catch (error) {
        console.error('Error setting language:', error);
      }
    }

    this.updateHeaderVisibility();
  }

  updateHeaderVisibility() {
    // Show header only if user is logged in and NOT in sign-in-flow
    const isInSignInFlow = this.router.url.includes('/sign-in-flow');
    this.showHeader = !!this.userData && !isInSignInFlow;
  }

  detectSmallScreen() {
    /*if (window.innerWidth <= 1000) { 
      this.popoverHandlerService.showAlertPopover('Por favor, conectase desde un dispositivo con una pantalla más grande.');
    }*/

    if (window.innerWidth <= 700) { 
      this.smallScreen = true;
    }
  }
  
}
